import { NgModule, ModuleWithProviders } from '@angular/core';
import { APP_INSIGHTS_CONFIG } from './tokens';
import { ApplicationInsightsService } from './application-insights.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    ApplicationInsightsService
  ]
})
export class AppInsightsModule {
  static forRoot(resolveFn: () => void ): ModuleWithProviders<AppInsightsModule> {
    return {
      ngModule: AppInsightsModule,
      providers: [
        {
          provide: APP_INSIGHTS_CONFIG, useFactory: resolveFn
        }
      ]
    };
  }

  // tslint:disable:no-unused-variable
  constructor(private appInsights: ApplicationInsightsService) {
  }
  // tslint:enable:no-unused-variable
}
